// src/lib/api.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://sicunet.com/api", // adjust this based on your FastAPI base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Reusable fetcher for SWR
export const fetcher = (url) => axiosInstance.get(url).then((res) => res.data);

export default axiosInstance;
